<template>
  <Layout>
    <div class="w-full flex bg-white px-6 border-b-2 border-grey-light">
      <!-- v-if="userCan(PERMISSIONS.CAN_VIEW_RESTAURANTS)" -->
      <div
        :class="{
          'w-auto px-6 font-medium h-12 flex items-center justify-center border-b-2 border-transparent hover:text-primary cursor-pointer': true,
          'text-primary border-primary': activeFilter === BUSINESS_HOUR_MENU_OPTIONS.WORKING_HOURS,
        }"
        @click="setFilter(BUSINESS_HOUR_MENU_OPTIONS.WORKING_HOURS)"
      >
        Business Hours
      </div>
      <!-- v-if="userCan(PERMISSIONS.CAN_VIEW_RESTAURANTS)" -->
      <div
        :class="{
          'w-auto px-6 font-medium h-12 flex items-center justify-center border-b-2 border-transparent hover:text-primary cursor-pointer': true,
          'text-primary border-primary': activeFilter === BUSINESS_HOUR_MENU_OPTIONS.SPECIAL_HOLIDAYS,
        }"
        @click="setFilter(BUSINESS_HOUR_MENU_OPTIONS.SPECIAL_HOLIDAYS)"
      >
        Special Holidays
      </div>
    </div>
    <keep-alive>
      <component
        :is="activeFilter"
        :selected-index="selectedIndex"
      />
    </keep-alive>
  </Layout>
</template>

<script>
import Layout from '@layouts/main';
import WorkingHours from './working-hours';
import SpecialHolidays from './special-holidays';
import {
  BUSINESS_HOUR_MENU_OPTIONS,
} from '@constants';

export default {
  name: 'BusinessHours',
  page: {
    title: 'Business Hours',
  },
  components: {
    Layout,
    WorkingHours,
    SpecialHolidays,
  },
  data() {
    return {
      BUSINESS_HOUR_MENU_OPTIONS,
      activeFilter: BUSINESS_HOUR_MENU_OPTIONS.WORKING_HOURS,
      selectedIndex: 0,
    };
  },
  methods: {
    setFilter(filter) {
      this.activeFilter = filter;
      this.selectedIndex++;
    },
  },
};
</script>
